<script>
    import { currency_formatter } from "../../globals";
    import Header from "../header.svelte"
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import { push } from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";
    import { api_host, user_store, all_users_store, expenses_store, expense_category_store } from '../../stores.js';
    import { init_data } from "../../init.js";
    import { onMount } from "svelte";
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import { formatDate } from "../../utils/format.js";
    import Swal from "sweetalert2";


    const { auth_type, auth_token, domain_code } = getToken();

    let is_busy = false;
    let content_title = "Accounting - Expenses";
    let all_clients = [];
    let all_vendors = [];
    let expense_categories = [];
    let expenses = [];

    let fields = [
        {
            "index": 0,
            "group": "row1",
            "type": "date",
            "label": "Date",
            "value": '',
            "name": "expense[date]",
            "validation_function": () => {
                if (fields[0].value.length > 0) {
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    fields[0]['error_text'] = 'Invalid Date';
                    return false;
                }
            }
        },
        {
            "index": 1,
            "group": "row1",
            "type": "select",
            "label": "Expense Account",
            "value": "",
            "select_options": [],
            "validation_function": () => {
                if (fields[1].value.length > 0) {
                    fields[1]['show_error'] = false;
                    return true;
                } else {
                    fields[1]['show_error'] = true;
                    fields[1]['error_text'] = 'Invalid Date';
                    return false;
                }
            }
        },
        {
            "index": 2,
            "group": "row2",
            "type": "select",
            "label": "Client",
            "value": "",
            "select_options": []
        },
        {
            "index": 3,
            "group": "row2",
            "type": "select",
            "label": "Vendor",
            "value": "",
            "select_options": [],
            "validation_function": () => {
                if (fields[3].value.length > 0) {
                    fields[3]['show_error'] = false;
                    return true;
                } else {
                    fields[3]['show_error'] = true;
                    fields[3]['error_text'] = 'Vendor is required';
                    return false;
                }
            }
        },
        {
            "index": 4,
            "group": "row1",
            "type": "text",
            "label": "Amount $",
            "value": "",
            "placeholder": "eg. 100",
            "validation_function": () => {
                if (parseFloat(fields[4].value) > 0) {
                    fields[4]['show_error'] = false;
                    return true;
                } else {
                    fields[4]['show_error'] = true;
                    fields[4]['error_text'] = 'Amount is required';
                    return false;
                }
            },
        },
        {
            "index": 5,
            "group": "row3",
            "type": "textarea",
            "label": "Description",
            "value": "",
            "maxlength": 200,
            "word_count_limit": 200
        },
    ];

    onMount(() => {
        init_data('expense_category');
        init_data('expenses');
    });

    user_store.subscribe(value => {
        if (value.plan_type !== 'free') {
            push('#/Dashboard');
        }
    });
    all_users_store.subscribe(value => {
        let clients = [];
        let _all_clients = [];
        let vendors = [];
        let _all_vendors = [];
        for (let i = 0; i < value.length; i ++) {
            const { first_name, last_name, email, role } = value[i];
            if (role === 'client') {
                clients.push(`${first_name} ${last_name} (${email})`);
                _all_clients.push(value[i]);
            }
            if (role === 'vendor') {
                vendors.push(`${first_name} ${last_name}`);
                _all_vendors.push(value[i]);
            }
        }
        fields[2].select_options = [...[''], ...clients];
        all_clients = _all_clients;
        fields[3].select_options = [...[''], ...vendors];
        all_vendors = _all_vendors;
    });
    expense_category_store.subscribe(value => {
        let expense_accounts = [];
        let _expense_categories = [];
        for (let i = 0; i < value.length; i ++) {
            const { account_name } = value[i];
            expense_accounts.push(account_name);
            _expense_categories.push(value[i]);
        }
        fields[1].select_options = expense_accounts;
        fields[1].value = expense_accounts[0];
        expense_categories = _expense_categories;
    });
    expenses_store.subscribe(value => {
        let _expenses = [];
        for (let i = 0; i < value.length; i ++) {
            const _expense = value[i];
            _expenses.push({
                'id': _expense.id,
                'bd': formatDate(_expense.bill_date),
                'v': _expense.vendor_name,
                'amount': currency_formatter.format(_expense.amount),
                'origin_desc': _expense.job ? `"${_expense.job.address}, ${_expense.job.city}, ${_expense.job.state}"` : _expense.description,
                'desc': _expense.job ? `<a sortValue='${_expense.job.address}, ${_expense.job.city}, ${_expense.job.state}' href='/#/Job_Review?jid=${_expense.job.id}'>${_expense.job.address}, ${_expense.job.city}, ${_expense.job.state}</a>` : _expense.description,
                'ec': _expense.expense_category || 'Labor',
                'job': _expense.job,
                'client': _expense.client ? `<a sortValue='${_expense.client_name}' href='/#/User_Review?uid=${_expense.client}'>${_expense.client_name}</a>` : (_expense.client_name || ''),
                'origin_client': _expense.client ? _expense.client_name : (_expense.client_name || ''),
            });
        }
        _expenses.sort((a, b) => {
            if (new Date(a.bd) < new Date(b.bd)) return 1;
            else return -1;
        })
        expenses = _expenses;
    });

    function resetExpenseFields() {
        fields[0].value = '';
        fields[4].value = '';
        fields[5].value = '';
    }

    let validateForm = () => {
        let is_valid = true;
        fields.forEach(field => {
            if (field.validation_function && !field.validation_function()) {
                is_valid = false;
            }
        });
        return is_valid;
    };

    async function addNewExpense() {
        if (validateForm()) {
            const client = all_clients.filter(_client => `${_client.first_name} ${_client.last_name} (${_client.email})` === fields[2].value);
            const vendor = all_vendors.filter(_vendor => `${_vendor.first_name} ${_vendor.last_name}` === fields[3].value);
            const expense_category = expense_categories.filter(category => category.account_name === fields[1].value);
            const payload = {
                'bill_date': fields[0].value,
                'expense_account_name': fields[1].value,
                'category_id': expense_category[0] ? expense_category[0].id : 0,
                'client': fields[2].value,
                'client_id': client[0] ? client[0].hoy_user : 0,
                'vendor': fields[3].value,
                'vendor_id': vendor[0] ? vendor[0].hoy_user : 0,
                'amount': fields[4].value,
                'description': fields[5].value
            };
            is_busy = true;
            const res = await doFetch(
                `${api_host}/api/expense/add`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                toast_message(true, res.msg, 3000);
                init_data('expenses');
                resetExpenseFields();
            } else {
                toast_message(false, res.msg || 'Bad request', 3000);
            }
            is_busy = false;
        } else {
            toast_message(false, 'Missing or invalid info', 3000);
        }
    }

    let show_add_expense = false;

    let table_header_config = [
        {'t': 'Bill Date', 'fm': 'bd', 'csv': 'bd', 'a': true},
        {'t': 'Vendor', 'fm': 'v', 'csv': 'v', 'a': true},
        {'t': 'Amount $', 'fm': 'amount', 'csv': 'amount', 'a': true},
        {'t': 'Description', 'fm': 'desc', 'csv': 'origin_desc', 'a': true},
        {'t': 'Expense Category', 'fm': 'ec', 'csv': 'ec', 'a': true},
        {'t': 'Client', 'fm': 'client', 'csv': 'origin_client', 'a': true}
    ];
    let action_items = [
        {"id": "edit", "i": "fas fa-edit", "s": "color: #ff9800;", "f": (id) => {
            const expense = expenses.filter(expense => expense.id === id);
            if (!expense[0].job) { push("#/Expense_Edit?eid=" + id); }
            else {             
                Swal.fire({
                    title: "Unable to edit",
                    text: '',
                    buttonsStyling: true,
                    cancelButtonText: "Cancel",
                    showConfirmButton: false,
                    showCancelButton: true,
                    icon: "warning"
                });
            }
        }},
        {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": async (id) => {
            Swal.fire({
                title: "Delete this expense?",
                text: '',
                buttonsStyling: true,
                confirmButtonClass: "button",
                confirmButtonText: 'Ok',
                cancelButtonText: "Cancel",
                showCancelButton: true,
                icon: "warning"
            }).then(async (e) => {
                if (e.isConfirmed) {
                    is_busy = true;
                    const res = await doFetch(
                        `${api_host}/api/expense/delete`,
                        'POST',
                        { expense_id: id },
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    if (res.status) {
                        toast_message(true, res.msg, 3000);
                        init_data('expenses');
                    } else {
                        toast_message(false, res.msg || 'Bad request', 3000);
                    }
                    is_busy = false;
                }
            });
        }},
    ];

    let sort_functions = {
        "amount": (el1, el2) => {return parseFloat(el1) - parseFloat(el2)},
    }

    let date_value = '';
</script>


<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="exportbuttonbar">
        <button class="addexpensebutton" on:click={() => {resetExpenseFields(); show_add_expense = true;}}>
            <i class="fas fa-plus"></i> Add Expense
        </button>
        &nbsp;
        <button
            class="addexpensebutton"
            on:click={() => { push('#/User_Create?user_type=Vendor') }}
            style="background-color: #ff9800;"
        >
            <i class="fas fa-book"></i> Add Vendor
        </button>
    </div>

    {#if show_add_expense}
    <br />
    <div class="section">
        <div class="addexpenseholder">
            <div class="toolsholder">
                {#each fields.filter((e) => e.group === "row1") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:value={nf.value}
                        bind:validation_function={nf.validation_function}
                        bind:change_function={nf.change_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                {/each}
            </div>

            <div class="toolsholder">
                {#each fields.filter((e) => e.group === "row2") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:value={nf.value}
                        bind:validation_function={nf.validation_function}
                        bind:change_function={nf.change_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                {/each}
            </div>

            <div class="toolsholder">
                {#each fields.filter((e) => e.group === "row3") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        maxlength={nf.maxlength}
                        word_count_limit={nf.word_count_limit}
                        bind:value={nf.value}
                        bind:validation_function={nf.validation_function}
                        bind:change_function={nf.change_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                {/each}
            </div>
            <div class="newexpensebuttonholder">
                <button class="savebutton" on:click={() => {addNewExpense("new_expense");}}>
                    <i class="fas fa-save"></i> Save
                </button>
                &nbsp;&nbsp;
                <button class="cancelbutton" on:click={() => {resetExpenseFields(); show_add_expense = false;}}>
                    <i class="fas fa-window-close"></i> Cancel
                </button>
            </div>
        </div>
    </div>
    {/if}

    <br />

    <div class="section">
        <div class="expenstableholder">
            <ResponsiveTable
                sort_functions={sort_functions} 
                num_per_page={100} 
                show_date_range={true}
                show_csv_export={true}
                csv_name='expenses'
                refresh_action='expenses'
                date_filter_param='bd'
                bind:date_value={date_value}
                bind:total_items={expenses.length} 
                bind:action_items={action_items}
                bind:table_header_config={table_header_config} 
                bind:table_data={expenses}
            />
        </div>
    </div>
</div>


<style>
    .contentholder {
        width: 100%;
    }
    .exportbuttonbar {
        margin-top: 10px;
        width: 100%;
        display: flex;
    }
    button.addexpensebutton{
        /* max-width: 300px; */
        /* width: 100%; */
        padding-left: 25px;
        padding-right: 25px;
        background-color: #357a38;
        color: white;
    }
    .newexpensebuttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
    .newexpensebuttonholder button{
        padding-left: 25px;
        padding-right: 25px;
    }
    .newexpensebuttonholder button.savebutton{
         background-color: #1c54b2;
         color: white;
    }
    .newexpensebuttonholder button.cancelbutton{
        background-color: #b2102f;
        color: white;
    }
    :global(.rowwrap .group) {
        min-width: 300px;
        max-width: 300px;
    }
    .toolsholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
    }
    :global(.toolsholder .group) {
        padding-left: 10px;
        padding-right: 10px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .toolsholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        :global(.toolsholder .group) {
            padding-left: 0px;
            padding-right: 0px;
        }
        .exportbuttonbar {
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .exportbuttonbar button {
            max-width: 100%;
            width: 100%;
            background-color: #ff9100;
            color: white;
        }
        button.addexpensebutton{
            max-width: 100%;
            width: 100%;
            background-color: #357a38;
            color: white;
        }
        .newexpensebuttonholder {
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: start;
        }
        .newexpensebuttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.rowwrap .group) {
            min-width: 100%;
            max-width: 100%;
        }
    }
</style>